module.exports = __webpack_public_path__ + "static/25-LG-4943d9630c66e5ca26a593c264827e2c.png";